module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am177-5b26128dbc6f57802333c7f60f550e7a.jpg";